import React, { useState } from 'react';
import { Flex } from 'deprecated-enkel';

import { InlineError } from 'ui/InlineError';
import { TotemButton } from 'ui/Button';
import { Logo } from 'components/Logo';

import { TotemLabel, TotemInput } from 'styles';
import {
    LoginBottomHalfStyle,
    LoginFormStyle,
    LoginStyle,
    LoginTopHalfStyle,
    LoginWrapperStyle,
    PasswordReminderText,
    BorderBottomLink,
    BorderBottomText,
} from 'styles/pages/login.styles';
import { SignupTitleStyle } from 'styles/pages/signup.styles';
import { SendResetPasswordMutation, useSendResetPasswordMutation } from 'data/__generated__';

export const RequestResetPassword: React.FC = () => {
    const [sendResetPassword] = useSendResetPasswordMutation();
    const [resetResult, setResetResult] = useState<SendResetPasswordMutation['sendResetPassword']>();

    const handleResetPassword = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const form = e.currentTarget;
        const emailInput = form.elements.namedItem('email') as HTMLInputElement | null;
        const emailAddress = emailInput?.value;
        if (emailAddress) {
            const response = await sendResetPassword({ variables: { emailAddress } });
            const result = response?.data?.sendResetPassword;
            setResetResult(result);
        }
    };

    const success = resetResult?.success;
    const error = resetResult?.error;

    return (
        <LoginStyle>
            <LoginTopHalfStyle>
                <Logo dark />
            </LoginTopHalfStyle>
            <LoginBottomHalfStyle>
                <LoginWrapperStyle>
                    {!success && (
                        <>
                            <SignupTitleStyle>Un mot de passe de perdu, dix de retrouvés</SignupTitleStyle>
                            <LoginFormStyle onSubmit={handleResetPassword}>
                                <TotemLabel color="white">
                                    Email Professionnel
                                    <TotemInput
                                        placeholder="Entrez l’email de votre compte"
                                        name="email"
                                        autoFocus
                                        data-test="login-username"
                                    />
                                    <InlineError display={error ?? ''} message={error ?? ''} />
                                </TotemLabel>
                                <Flex $alignItems="center" $direction="column">
                                    <TotemButton $margins={[1, 0, 1, 0]} type="submit" data-test="login-submit">
                                        M'envoyer un email
                                    </TotemButton>
                                    <BorderBottomText>
                                        Un retour de mémoire ?{' '}
                                        <BorderBottomLink to="/login">Connectez-vous</BorderBottomLink>
                                    </BorderBottomText>
                                </Flex>
                            </LoginFormStyle>
                        </>
                    )}
                    {success && (
                        <>
                            <PasswordReminderText yellow fontWeight="600">
                                Email trouvé !
                            </PasswordReminderText>
                            <PasswordReminderText> Vous devriez avoir reçu un lien par email.</PasswordReminderText>
                            <PasswordReminderText>
                                Cliquez dessus pour réinitialiser votre mot de passe !
                            </PasswordReminderText>
                        </>
                    )}
                </LoginWrapperStyle>
            </LoginBottomHalfStyle>
        </LoginStyle>
    );
};
